
/* eslint-disable */
import axios from 'axios';

export default {
    state : {
        postavshiks : [],
    },

    methods : {

    },

    getters : {

        getPostavshiks(state) {

            return state.postavshiks;

        },

        getPostavshikById: (state) => (id) => {
            return state.postavshiks.find(item => item.id === id)
        },


    },

    mutations: {
        deletePostavshik(state, id) {
            const index =  state.postavshiks.findIndex(item => item.id === id);
            state.postavshiks.splice(index, 1);
        },

        setPostavshiks(state, postavshiks) {
            state.postavshiks = postavshiks;
        },

        setPostavshik(state, postavshik) {
            const index =  state.postavshiks.findIndex(item => item.id === postavshik.id);
            if (index>-1) state.postavshiks.splice(index, 1, postavshik);
            else state.postavshiks.push(postavshik);
        }
    
    },

    actions : {



        lockPostavshik({ rootState, rootGetters }, id){

            return new Promise((resolve, reject) => {
                axios.post('/postavshiks/lock/' + id, {id:id})
                .then(response => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'setPostavshik', 'content' : response.data});
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            });

        },
        unlockPostavshik({ rootState, rootGetters }, id) {
            return new Promise((resolve, reject) => {
                axios.post('/postavshiks/unlock/' + id, {id:id})
                .then(response => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'setPostavshik', 'content' : response.data});
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
            });
        },

        getAllPostavshiks({dispatch, commit, rootState }) {

            return new Promise((resolve, reject) => {
                    axios.get('/postavshiks')
                    .then(response => {
                        commit('setPostavshiks', response.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        if ((error.response.status == 401)||(error.response.status == 500)) {
                            console.log(error)
                        }
                        else {
                            let t = error.response.status == 429 ? 15000 : 1500;
                            if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];
                            setTimeout(()=>{        // повторная загрузка через секунду
                                dispatch('getAllPostavshiks');
                            }, t);
                        }
                        reject(error.response.status)
                    });
            });
        },

        savePostavshik({dispatch, commit, rootState, rootGetters }, item) {

            return new Promise((resolve, reject) => {
                axios.post('/postavshiks', item)
                .then(response => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'setPostavshik', 'content' : response.data});
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
            });

        },

        deletePostavshik({rootState, rootGetters }, item) {

            return new Promise((resolve, reject) => {
                axios.delete('/postavshiks/'+item.id)
                .then(response => {
                    rootState.ds.event.emit(rootGetters.getPrefix, {'event':'deletePostavshik', 'content' : item.id});
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error)
                });
            });

        },


    }

}